module.exports = __webpack_public_path__ + "static/truck-9b0e7b639da6521f98d4cda287bfed67.jpg";